import React, { useMemo } from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import adminServices from '../../services/adminServices';
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import FilterDataTable from '../../pages/instructor/FilterDataTable';
import Navbar from '../shared/Navbar';
import StickyMenu from '../../components/common/StickyMenu';
import Sidebar from '../shared/Sidebar';
import DataTable from 'react-data-table-component';
import SettingsPanel from '../shared/SettingsPanel';
import { Button, Col, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import cookies from "js-cookie";
import { useTranslation } from 'react-i18next';
import UserService from '../../services/UserService';
import Footer from '../shared/Footer';
import moment from 'moment';
import ProgressBar from '@ramonak/react-progress-bar';
import service from '../../services/service';


const languages = [
    {
        code: "en",
        name: "English",
        country_code: "gb",
    },

    {
        code: "hi",
        name: "Hindi",
        country_code: "in",
    },
    // {
    //     code: 'te',
    //     name: 'Telugu',
    //     country_code: 'in'
    // },
    {
        code: "pu",
        name: "Punjabi",
        country_code: "in",
    },
    // {
    //     code : 'mr',
    //     name : 'Marathi',
    //     country_code : 'in'
    // }
];

const customStyles = {
    title: {
        style: {
            fontColor: "red",
            fontWeight: "900",
        },
    },
    headCells: {
        style: {
            fontSize: "17px",
            fontWeight: "500",
            paddingLeft: "0 8px",
            marginLeft: "10px",
        },
    },
    cells: {
        style: {
            fontSize: "15px",
            // paddingLeft: '0 8px',
            // marginLeft: '10px'
        },
    },
};

export default function InstructorList() {

    let userId = UserService.getUserid();
    const currentLanguageCode = cookies.get("i18next") || "en";
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode);
    const { t } = useTranslation();
    const [tenantId, setTenanatId] = useState();
    const [showModal, setShowModal] = useState({
        showModalStatus: false,
        name: '',
        email: '',
        mobile: '',
        education: '',
        gender: '',
        address: '',
        districtName: '',
        state: '',
        designation: '',
        instituteName: '',
        pincode: '',
        placeOfPosting: ''
    });

    /////// Instrutor Storage Details
    const [showStorageModal, setShowStorageModal] = useState(false);
    const [previousStorageAssigned, setPreviousStorageAssigned] = useState(0);
    const [storageData, setStorageData] = useState({ userId: null, storageUsed: null, storageAssigned: null });
    const [allInstStorageData, setAllInstStorageData] = useState([]);
    const [userStorageData, setUserStorageData] = useState({});
    const [userStorageFull, setUserStorageFull] = useState(false);
    const [availableStorageToAssign, setAvailableStorageToAssign] = useState(0);
    const [totalAssignedStorage, setTotalAssignedStorage] = useState(0);


    const MbToGb = (mb) => {
        if (mb === 0) return 0;
        const gb = mb / 1024;
        return +gb.toFixed(2);
    };

    const gbToMb = (gb) => {
        const mb = gb * 1024;
        return mb;
    };

    const [getAllUserStorageData, setgetAllUserStorageData] = useState([]);
    const [superAdminStorageDetail, setSuperAdminStorageDetail] = useState({});

    const getAllAdminStorageData = () => {
        service.getAllUserStorage()
            .then((response) => {
                // Handle the response here
                 //console.log(response?.data);
                setgetAllUserStorageData(response?.data);
                setSuperAdminStorageDetail(response?.data.find(user => user.userId === userId))
            })
            .catch((error) => {
                swal(`ERROR`, "Error Fetching the admin stoarge data!", "error")
                // Handle any errors here
                // console.error('Error fetching data:', error);
            });
    };

    const updateSystemAvailableStorage = () => {
        service.getTotalSystemAvailableStorage()
            .then((res) => {
                if (res.status == 200) {
                    //console.log(res.data);
                    getAllAdminStorageData();
                }
                else {
                    swal(`ERROR`, "Error Fetching the available system stoarge!", "error")
                }
            })
    }

    const fetchUserStorageData = () => {
        service.getUserStorage(userId)
            .then((res) => {
                //console.log(res);
                setUserStorageData(res.data);

                if (res.data.storageUsed >= res.data.storageAssigned) {
                    setUserStorageFull(true);
                } else {
                    setUserStorageFull(false);
                }
            })
            .catch((err) => {
                //console.log(err);
                swal(t("error"), err, "error");
            });
    }

    const getAllInstructorStorageData = () => {
        service.getAllUserStorage()
            .then((response) => {
                // Handle the response here
                //  //console.log(response?.data);
                setAllInstStorageData(response?.data);
            })
            .catch((error) => {
                // Handle any errors here
                console.error('Error fetching data:', error);
            });
    };

    const getAdminAvailableStorageToAssign = () => {
        service.getAvailableStorageToAssign()
            .then((response) => {
                //console.log(response?.data);
                setAvailableStorageToAssign(response?.data);
            })
            .catch((error) => {
                swal(`ERROR`, "Error Fetching the admin Available Stoarge data!", "error")
                // Handle any errors here
                // console.error('Error fetching data:', error);
            });
    };

    useEffect(() => {
        //console.log("Called");
        getAllInstructorStorageData();
        fetchUserStorageData();
        getAdminAvailableStorageToAssign();
        updateSystemAvailableStorage();
    }, [])

    //console.log("userStorageData.storageAssigned: ", userStorageData.storageAssigned);
    //console.log("totalAssignedStorage: ", totalAssignedStorage);
    //console.log("availableStorageToAssign: ", availableStorageToAssign);
    //console.log("storageData: ", storageData);


    const [totalPage, setTotalPage] = useState()
    const [page, setPage] = useState(0);

    useEffect(() => {
        document.body.dir = currentLanguage.dir || "ltr";
        document.title = t("app_title");
    }, [currentLanguage, t]);

    useEffect(() => {
        UserService.generateToken();
        UserService.getAttribute().then((resp) => {
            //console.log(resp)
            LearnersDatas(resp);
            setTenanatId(resp)
        })
    }, [allInstStorageData]);

    const [getLearnerData, setlearnerData] = useState([]);

    const LearnersDatas = (tenantId) => {
        let sumAssignedStorage = 0;
        service.getInstructorListUploadedByAndTenantId(UserService.getUserid(), 1).then((response) => {
            const updatedLearnerData = response.data.map(learner => {
                const storageData = allInstStorageData.find(
                    storage => storage.userId == learner.learnerUsername
                );
                //console.log("storage: ", storageData);
                if (storageData) {
                    sumAssignedStorage += storageData.storageAssigned;
                    return {
                        ...learner,
                        storageUsed: MbToGb(storageData.storageUsed),
                        storageAssigned: MbToGb(storageData.storageAssigned),
                    };
                } else {
                    return {
                        ...learner,
                        storageUsed: 0,
                        storageAssigned: 0,
                    };
                }
            });

            setTotalAssignedStorage(sumAssignedStorage);
            setlearnerData(updatedLearnerData);
            //console.log(updatedLearnerData);
        }).catch(e => {
            //console.log(e);
        })
    };

    const handleStorageModalClose = () => setShowStorageModal(false);
    const handleStorageModalShow = (row) => {
        setStorageData({ userId: row.learnerUsername, storageUsed: row.storageUsed, storageAssigned: row.storageAssigned });
        setShowStorageModal(true);
    };

    const handleStorageAssignedChange = (event) => {
        // Parse the input value to a floating point number
        const inputAsFloat = parseFloat(event.target.value);

        // Check if the parsed value is NaN and use a fallback value if necessary
        const safeInputValue = isNaN(inputAsFloat) ? storageData.storageUsed : inputAsFloat;

        // Calculate the new storageAssigned, ensuring it's not less than storageUsed
        const newStorageAssigned = Math.max(storageData.storageUsed, safeInputValue);

        setPreviousStorageAssigned(storageData.storageAssigned);

        // Update the state with the new value
        setStorageData({
            ...storageData,
            storageAssigned: newStorageAssigned,
        });
    };

    const handleUpdateStorage = () => {
        let newAssignedStorage = gbToMb(storageData.storageAssigned);
        let userId = storageData.userId;

        console.log("previousStorageAssigned: ", previousStorageAssigned);
        console.log("gbToMb -previousStorageAssigned: ", gbToMb(previousStorageAssigned));
        console.log("newAssignedStorage: ", newAssignedStorage);

        const storageDifference = newAssignedStorage - gbToMb(previousStorageAssigned);
        console.log("storageDifference: ", storageDifference);

        if (storageDifference >= availableStorageToAssign) {
            swal(`ERROR`, "Exceeds Available Sorage Space!", "error")
            return
        }

        console.log("newAssignedStorage: ", newAssignedStorage);
        //console.log("userId: ", userId);

        service.updateUserStorage(userId, newAssignedStorage)
            .then((response) => {
                setShowStorageModal(false);
                if (response.status == 200) {
                    swal(`${t('success')}`, response.data, "success")
                    getAllInstructorStorageData();
                    getAdminAvailableStorageToAssign();

                } else {
                    swal(`Failed`, response.data, "error")
                }
            })
            .catch((error) => {
                // Handle any errors here
                setShowStorageModal(false);
                console.error('Error fetching data:', error);
            });

    }

    const enableUser = (userId) => {
        //console.log(userId)

        setEnableLoading({ isLoading: true });

        adminServices
            .enableLearnerUser(userId)
            .then((resp) => {
                if (resp.status === 200) {
                    //console.log(tenantId)
                    swal(`${t("success")}`, `${t("user_enable_msg")}`, "success")
                    LearnersDatas(tenantId);
                    setEnableLoading({ isLoading: false });
                }
            }).catch((err) => {
                //console.log("inside the Catch enable")
                setEnableLoading({ isLoading: false });
                swal(
                    `${t("error")}`,
                    `${t("something_went_wrong_try_later")}`,
                    "error"
                );
            });
    };

    const disableUser = (userId) => {
        //console.log(userId)
        setDisableLoading({ isLoading: true });
        adminServices.disableLearnerUser(userId)
            .then((resp) => {
                //console.log("Enable user == ",resp.status)
                if (resp.status === 200) {
                    //console.log("Inside if Disable user == ",resp.status)

                    swal(t("success"), t("user_disable_msg"), "success");
                    setDisableLoading({ isLoading: false });
                    LearnersDatas(tenantId);


                };
            }
                // window.location.reload();

                //console.log(resp.data);
            )
            .catch((err) => {
                //console.log("inside the Catch disable")

                setDisableLoading({ isLoading: false });
                swal(
                    `${t("error")}`,
                    `${t("something_went_wrong_try_later")}`,
                    "error"
                );
                //console.log(err);
            });
    };


    const removeLearner = (learnerId) => {

        //console.log("learnerId = ", learnerId)

        Swal.fire({
            title: "Please Wait",
            didOpen: () => {
                Swal.showLoading();
                adminServices.removeLearner(UserService.getUserid(), learnerId).then((resp) => {
                    if (resp.data === "success") {
                        Swal.fire({
                            icon: "success",
                            text: "User Delete Successfully",
                            showConfirmButton: false,
                            timer: 2000,
                        })
                        LearnersDatas(tenantId);
                    }
                }).catch((error) => {
                    Swal.fire({
                        icon: "error",
                        text: "Something went Wrong Try Later",
                        showConfirmButton: false,
                        timer: 2000,
                    })
                })
            }
        })
    }


    const columns = [
        {
            name: "S.No",
            selector: (row, index) => index + 1,
            sortable: true,
            width: "100px",
        },
        {
            name: "Name",
            selector: (row) => `${row.firstName} ${row.lastName}`,
            sortable: true,
            wrap: true,
        },
        {
            name: "Email",
            selector: (row) => row.email,
            wrap: true,
            sortable: true,
        },
        // {
        //     name: "Mobile",
        //     selector: (row) => row.mobile.split(".")[0],
        //     sortable: true,
        // },
        {
            name: "Storage",
            sortable: true,
            cell: (row) =>
                <>
                    {
                        row.status.toLowerCase() !== "registered"
                            ?
                            <>
                                <Button
                                    variant="primary"
                                    onClick={() => handleStorageModalShow(row)}
                                    size='sm'
                                >
                                    {row.storageUsed} GB/{row.storageAssigned} GB
                                </Button>
                            </>
                            :
                            <>
                            </>
                    }
                </>
            ,
        },
        {
            name: "Status",
            selector: (row) => row.status,
            sortable: true,
        },
        {
            name: "Action",
            sortable: true,
            wrap: true,
            cell: (row) => (
                <div>
                    <>
                        <div className="row">
                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">User Info</Tooltip>}>
                                <button className="btn btn-info btn-sm" onClick={() => {
                                    setShowModal({
                                        ...showModal,
                                        showModalStatus: true,
                                        name: row?.firstName + ' ' + row?.lastName,
                                        email: row?.email,
                                        mobile: row?.mobile.split('.')[0],
                                        designation: row?.designation,
                                        gender: row?.gender,
                                        education: row?.eduQualification,
                                        instituteName: row?.instituteName,
                                        address: row?.address,
                                        districtName: row?.districtMaster?.districtName,
                                        state: row?.stateMaster?.stateName,
                                        pincode: row?.pincode,
                                        placeOfPosting: row?.placeOfPosting
                                    })


                                }} style={{ margin: "5px" }}><i class="fa fa-info" aria-hidden="true"></i></button>
                            </OverlayTrigger>
                            {
                                row.status.toLowerCase() == "registered"
                                    ?
                                    <>
                                        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Remove User</Tooltip>}>
                                            <button className="btn btn-danger btn-sm" onClick={() => { removeLearner(row.email) }} style={{ margin: "5px" }}><i class="fa fa-trash" aria-hidden="true"></i></button>
                                        </OverlayTrigger>
                                    </>
                                    :
                                    <>
                                        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Send Temporary Password</Tooltip>}>
                                            <button className="btn btn-primary btn-sm" onClick={() => { sendMailOnClick(row.learnerUsername) }} style={{ margin: "5px" }}><i class="fa fa-brands fa-telegram"></i></button>
                                        </OverlayTrigger>
                                        {
                                            row.status.toLowerCase() == "approved" ?
                                                <>
                                                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Block User</Tooltip>}>
                                                        <button className="btn btn-danger btn-sm" onClick={() => { disableUser(row.learnerUsername) }} style={{ margin: "5px" }}><i class="fa fa-solid fa-lock"></i></button>
                                                    </OverlayTrigger>
                                                </>
                                                :
                                                <>
                                                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Unblock User</Tooltip>}>
                                                        <button className="btn btn-success btn-sm" onClick={() => { enableUser(row.learnerUsername) }} style={{ margin: "5px" }}><i class="fa fa-solid fa-unlock"></i></button>
                                                    </OverlayTrigger>
                                                </>
                                        }
                                    </>
                            }
                        </div>
                    </>
                </div>
            ),
        },
    ];

    const sendMailOnClick = (uid) => {

        Swal.fire({
            title: "Please Wait",
            text: "Mail is Sending",
            didOpen: () => {
                Swal.showLoading();
                adminServices.sendMailTempPasswordToLI(uid).then((resp) => {
                    if (resp.data != "fail") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Mail Send Successfully',
                            showConfirmButton: false,
                            timer: 3000
                        })
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Something Went Wrong',
                            showConfirmButton: false,
                            timer: 3000
                        })
                    }
                }).catch((err) => {

                })
            }
        })

    }

    /* Table content Filter and Search */
    const [filterText, setFilterText] = React.useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
    const filteredItems = getLearnerData.filter(
        (item) =>
            JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !==
            -1
    );

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };

        return (
            <FilterDataTable
                onFilter={(e) => setFilterText(e.target.value)}
                onClear={handleClear}
                filterText={filterText}
            />
        );
    }, [filterText, resetPaginationToggle]);

    const [ShareUrlModal, setShareUrlModal] = useState({
        show: false,
    });

    const [infoLoading, setInfoLoading] = useState({
        isLoading: false,
    });
    const [enableLoading, setEnableLoading] = useState({
        isLoading: false,
    });
    const [disableLoading, setDisableLoading] = useState({
        isLoading: false,
    });

    const shareUrlModalHide = () => {
        setShareUrlModal({ show: false });
        setInfoLoading({ isLoading: false });
    };
    const shareUrlModalShow = (
        firstname,
        lastname,
        email,
        mobile,
        gender,
        address,
        city,
        district,
        state,
        pincode,
        country,
        qualification,
        institute,
        dob
    ) => {
        setInfoLoading({ isLoading: true });
        setShareUrlModal({
            show: true,
            firstName: firstname,
            lastName: lastname,
            email: email,
            mobile: mobile,
            gender: gender,
            address: address,
            district: district,
            state: state,
            pincode: pincode,
            country: country,
            qualification: qualification,
            institute: institute,
            dob: dob,
            city: city,
        });
    };

    const pageHandler = (page) => {
        setPage(page);
        //console.log(page)
    }

    return (
        <div>
            <div className="container-scroller">
                <Navbar />
                <StickyMenu />
                <div className="container-fluid page-body-wrapper">
                    <Sidebar />
                    <div className="main-panel">
                        <div className="content-wrapper">
                            <div>
                                <div className="page-header">
                                    <h3 className="page-title">Instructors list</h3>
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <a href="!#" onClick={(event) => event.preventDefault()}>
                                                    Instructors
                                                </a>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">
                                                Instructors list
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-lg-12 grid-margin stretch-card">
                                    <div className="card">
                                        <div className="card-body">
                                            <Col lg={12}>
                                                <div>
                                                    <h6>Used Storage: {MbToGb(userStorageData.storageUsed)} GB / {MbToGb(userStorageData.storageAssigned)} GB</h6>
                                                </div>

                                                <div style={{ width: "50%", marginTop: "10px" }}>
                                                    <ProgressBar
                                                        completed={Math.ceil((MbToGb(userStorageData.storageUsed) / MbToGb(userStorageData.storageAssigned)) * 100) || 1}
                                                        baseBgColor="#e0e0de"
                                                        maxCompleted={100}
                                                        bgColor={((MbToGb(userStorageData.storageUsed) / MbToGb(userStorageData.storageAssigned)) * 100) >= 95 ? "#f51111" : "#11B67A"}
                                                        height='18px'
                                                        animateOnRender={true}
                                                        isLabelVisible={true}
                                                        transitionTimingFunction={'ease-in-out'}
                                                    />
                                                </div>

                                                <div style={{ marginTop: "10px" }}>
                                                    <h6>Total Assigned Storage: {MbToGb(totalAssignedStorage)} GB / {MbToGb(userStorageData.storageAssigned)} GB</h6>
                                                </div>

                                                <div style={{ marginTop: "10px" }}>
                                                    <h6>Total Available Storage To Assign: {MbToGb(availableStorageToAssign)} GB / {MbToGb(userStorageData.storageAssigned)} GB</h6>
                                                </div>

                                            </Col>
                                            <DataTable
                                                columns={columns}
                                                data={filteredItems}
                                                defaultSortField="Name"
                                                defaultSortAsc={true}
                                                striped
                                                pagination
                                                // onChangePage={pageHandler}
                                                highlightOnHover
                                                customStyles={customStyles}
                                                subHeader
                                                subHeaderComponent={subHeaderComponent}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <SettingsPanel />
                        </div>
                        <Footer />
                    </div>
                </div>
                <Modal centered show={showModal.showModalStatus} onHide={() =>
                    setShowModal({
                        ...showModal,
                        showModalStatus: false
                    })
                }>
                    <Modal.Header closeButton>
                        <Modal.Title>User Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <table class="table table-borderless">
                            <tbody>
                                <tr>
                                    <td>Name</td>
                                    <td>:</td>
                                    <td>{showModal.name}</td>
                                </tr>
                                <tr>
                                    <td>Email</td>
                                    <td>:</td>
                                    <td>{showModal.email}</td>
                                </tr>
                                <tr>
                                    <td>Gender</td>
                                    <td>:</td>
                                    <td>{(showModal.gender !== null && showModal.gender !== "NA") ? showModal.gender : ''}</td>
                                </tr>
                                {/* <tr>
                                    <td>Mobile No.</td>
                                    <td>:</td>
                                    <td>{showModal.mobile}</td>
                                </tr>
                                <tr>
                                    <td>Address</td>
                                    <td>:</td>
                                    <td>{showModal.address !== null && showModal.address !== "NA" ? showModal.address : ''}</td>
                                </tr>
                                <tr>
                                    <td>District</td>
                                    <td>:</td>
                                    <td>{showModal.districtName !== null && showModal.districtName !== "NA" && showModal.districtName !== "PLEASE SELECT DISTRICT" ? showModal.districtName : ''}</td>
                                </tr>
                                <tr>
                                    <td>State</td>
                                    <td>:</td>
                                    <td>{showModal.state !== null && showModal.state !== "NA" && showModal.state !== "Please Select State" ? showModal.state : ''}</td>
                                </tr>
                                <tr>
                                    <td>Pincode</td>
                                    <td>:</td>
                                    <td>{showModal.pincode !== null && showModal.pincode !== "NA" && showModal.pincode !== 0 ? showModal.pincode : ''}</td>
                                </tr>
                                <tr>
                                    <td>Place of Posting</td>
                                    <td>:</td>
                                    <td>{showModal.placeOfPosting !== null && showModal.placeOfPosting !== "NA" ? showModal.placeOfPosting : ''}</td>
                                </tr> */}
                                {/* <tr>
                                    <td>Qualification</td>
                                    <td>:</td>
                                    <td>{(showModal.education !== null && showModal.education !== "NA") ? showModal.education : ''}</td>
                                </tr>
                                <tr>
                                    <td>Institute</td>
                                    <td>:</td>
                                    <td>{(showModal.instituteName !== null && showModal.instituteName !== "NA") ? showModal.instituteName : ''}</td>
                                </tr> */}

                            </tbody>
                        </table>
                    </Modal.Body>
                    <Modal.Footer style={{ justifyContent: "right" }}>
                        <Button onClick={() =>
                            setShowModal({
                                ...showModal,
                                showModalStatus: false
                            })
                        }
                        >Close</Button>
                    </Modal.Footer>
                </Modal>

                {/* STORAGE MODAL */}
                <Modal
                    show={showStorageModal}
                    onHide={handleStorageModalClose}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Instructor Storage Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: "20px" }}>
                        <div style={{ marginBottom: "15px" }}>
                            <p style={{ marginBottom: "5px", fontSize: "18px", fontWeight: "bold" }}>Storage Used: {(storageData.storageUsed)} GB</p>
                        </div>
                        <div style={{ marginBottom: "15px" }}>
                            <p style={{ marginBottom: "5px", fontSize: "18px", fontWeight: "bold", display: "inline-block", marginRight: "10px" }}>Storage Assigned:</p>
                            <div style={{ display: "inline-flex", alignItems: "center" }}>
                                <input
                                    type="number"
                                    value={storageData.storageAssigned}
                                    onChange={handleStorageAssignedChange}
                                    style={{
                                        width: "150px",
                                        padding: "10px",
                                        marginRight: "5px",
                                        fontSize: "16px",
                                    }}
                                />
                                <span style={{ fontSize: "16px" }}>GB</span>
                            </div>

                            <div>
                                <p style={{ marginBottom: "5px", fontSize: "18px", fontWeight: "bold" }}>Available Storage: {MbToGb(availableStorageToAssign)} GB</p>
                            </div>
                        </div>
                        {/* Add input field for updating storageAssigned value here */}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleStorageModalClose}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={handleUpdateStorage}>
                            Update
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>

        </div>
    )
}

